import { render, staticRenderFns } from "./culturalRelics.vue?vue&type=template&id=099db5aa&scoped=true"
import script from "./culturalRelics.vue?vue&type=script&setup=true&lang=js"
export * from "./culturalRelics.vue?vue&type=script&setup=true&lang=js"
import style0 from "./culturalRelics.vue?vue&type=style&index=0&id=099db5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099db5aa",
  null
  
)

export default component.exports